import CourseSectionMeetingService from "../CourseSectionMeeting/CourseSectionMeeting.service";
export default class CourseSectionService {
    static fromJSON(json) {
        return Object.assign(Object.assign({}, json), { courseSectionStart: json.courseSectionStart && new Date(json.courseSectionStart), courseSectionEnd: json.courseSectionEnd && new Date(json.courseSectionEnd), meetings: json.meetings &&
                json.meetings.map(CourseSectionMeetingService.fromJSON), censusDate: json.censusDate ? new Date(json.censusDate) : null, withdrawByDate: json.withdrawByDate
                ? new Date(json.withdrawByDate)
                : null });
    }
}
